import { useForm } from '@mantine/form';
import { useTranslation } from 'react-i18next';

import { CreateAssetDtoSubTypeEnum, CreateAssetDtoTypeEnum } from 'src/Services/API/generated';

export const useCreateAssetForm = (initialData: { subType?: CreateAssetDtoSubTypeEnum }) => {
  const { t } = useTranslation();

  return useForm({
    initialValues: {
      type: CreateAssetDtoTypeEnum.RealEstate,
      name: '',
      placeId: '',
      subType: initialData.subType,
    },
    validate: {
      name: (value: string) =>
        value.length < 2 ? t('forms.onboarding.invalidName', 'Nom invalide') : null,
      placeId: (value?: string) =>
        value
          ? null
          : t(
              'forms.invalidAddress',
              'Adresse invalide, veuillez en sélectionner une dans le menu déroulant'
            ),
      subType: value =>
        value ? null : t('forms.onboarding.emptySubType', 'Le type de formule est requis'),
    },
    transformValues: values => {
      return {
        ...values,
        subType: values.subType!,
      };
    },
  });
};
